import React, { useContext, useState } from 'react';
import HeaderPreview from '../../../GeneratePdf/HeaderPreview';
import FooterPreview from '../../../GeneratePdf/FooterPreview';
import { initialDataLeaderShip } from './QuadrantInFocus';
import GroupReportContext from '../../../../Context/GroupReportContext';

const styles = {
  container: { paddingTop: '16px' },
  heading: { fontSize: "14px", paddingBottom: "16px", lineHeight: "18px", fontWeight: 700, color: "#426B88", margin: 0, fontFamily: "'Helvetica', sans-serif", letterSpacing: 0 },
  description: { marginBottom: "16px", color: "#000000", marginTop: 0, fontFamily: "'Helvetica', sans-serif", fontWeight: 400, fontStyle: 'normal', fontSize: '10px', lineHeight: '14px', letterSpacing: '0px' },  tableWrapper: { overflow: "hidden", border: "0.25px solid #0000001A", borderRadius: "10px" },
  table: { width: "100%", borderCollapse: "separate", borderSpacing: "0", lineHeight: "13px", },
  th: { padding: "0 12px", backgroundColor: "#245775", color: "white", textAlign: "center", fontFamily: 'Helvetica', fontWeight: 400, lineHeight: "13px", fontStyle: 'normal', fontSize: '9px', letterSpacing: '0px' },
  td: { borderLeft: "0.67px solid #ddd", padding: "5px", textAlign: "center", fontFamily: 'Helvetica', fontWeight: 400, fontStyle: 'normal', fontSize: '9px', letterSpacing: '0px', color: "#000000" },  
  strategicColumn: { width: "100%", textAlign: "left", padding: "5.5px 15px", border: "none" },
  rowEven: { backgroundColor: "#FFF" },
  rowOdd: { backgroundColor: "#F1F3F3" },
  rectangleWrapper: { display: "flex", justifyContent: "center", alignItems: "center", height: "26px", width: "25px", margin: "0 auto" },
  rectangle: { width: "16px", height: "16px", backgroundColor: "#667F96", borderRadius: "1.34px" }
};

export default function StrategicGroupPreview({ apiData, previewData, reportType, pageNumber }) {
  // console.log('StrategicGroupPreview apiData:', apiData);
  // console.log('StrategicGroupPreview previewData:', previewData);

  const groupReportCtx = useContext(GroupReportContext)
  const [dynamicData, setDynamicData] = useState([...initialDataLeaderShip]);

  const renderRectangle = (avgScore, index) => {
    const full = Math.floor(avgScore);
    const partial = avgScore - full;
    if (index < full) {
      // Full square
      return <div style={styles.rectangle}></div>;
    } else if (index === full && partial > 0) {
      // Partial square (only color part, no light background)
      return (
        <div style={{ ...styles.rectangle, position: 'relative', overflow: 'hidden', backgroundColor: 'transparent' }}>
          <div style={{
            position: 'absolute',
            left: 0,
            top: 0,
            width: `${partial * 100}%`,
            height: '100%',
            backgroundColor: '#667f96',
            borderRadius: '2px',
            zIndex: 2,
          }}></div>
        </div>
      );
    } else {
      return null;
    }
  };
  const questions = [
    { id: 1, question: "When leading through conflict, I follow a specific process to work through it." },
    { id: 2, question: "I am at my best when creating standardized processes that help others achieve their goals more easily." },
    { id: 3, question: "I believe leading an organization requires a unified set of operating principles." },
    { id: 4, question: "My most important responsibility is the long-term stewardship of organizational assets." },
    { id: 5, question: "I believe effective strategy is primary." },
    { id: 6, question: "I am motivated by developing a clear strategic plan." },
    { id: 7, question: "I believe strategic thinking is the main contributor of success." },
    { id: 8, question: "I intentionally develop others by educating them on what they need to know." },
    { id: 9, question: "I believe success is contingent on thinking smarter." },
    { id: 10, question: "I find great satisfaction in developing effective strategies for our organization." },
  ];

  // Show only items 21-40 (index 20 onwards)
  const displayData = dynamicData?.filter((el) => el.quadrant == "STRATEGIC" );
  const allVariableSets = Array.isArray(apiData?.results) ? apiData.results.map((el) => el.variables) : [];

  const quadrantScores = {
    "PERFORMANCE": 1,
    "STRATEGIC": 2,
    "VISIONARY": 3,
    "COLLABORATIVE": 4
  }
  const allResults = [];
  displayData?.forEach((el, index) => {
    // console.log(el.quadrant, quadrantScores?.[el.quadrant])
    const res = groupReportCtx?.calculateQuestionScoreLeadership(quadrantScores?.[el.quadrant], allVariableSets, index + 1, "in_focus");
    if (res?.averageScore !== null && quadrantScores?.[el.quadrant] == 2) {
      allResults.push(res);
    }
  })

  // console.log("allResults", allResults)

  return (
    <div>
      <HeaderPreview />
      <div style={styles.container}>
        <h1 style={styles.heading}>STRATEGIC LEADERSHIP IN FOCUS</h1>
        <p style={styles.description}>
          This chart isolates the items related to Strategic Leadership based on the combined ratings of participants. The response scale runs from 1 (Least) to 4 (Most). Any unselected statement will appear blank in the In Focus section.
        </p>

        <div style={styles.tableWrapper}>
          <table style={styles.table}>
            <thead>
              <tr>
                <th style={{ ...styles.th, ...styles.strategicColumn }}>Strategic</th>
                <th style={{ ...styles.th }}>Score</th>
                {[1, 2, 3, 4].map((num) => (
                  <th key={num} style={styles.th}>
                    {num}
                  </th>
                ))}
              </tr>
            </thead>
            <tbody>
              {questions.map((item, index) => {
                const avgScore = allResults[index]?.averageScore;
                return (
                  <tr
                    key={index}
                    style={(index % 2) === 0 ? styles.rowOdd : styles.rowEven}
                  >
                    <td style={{ ...styles.td, ...styles.strategicColumn }}>
                      {item.question}
                    </td>
                    <td style={{ ...styles.td }}> {parseFloat(avgScore) > 0 ? avgScore : "-"} </td>
                    {[0, 1, 2, 3].map((idx) => (
                      <td key={idx} style={styles.td}>
                        <div style={styles.rectangleWrapper}>
                          {renderRectangle(avgScore, idx)}
                        </div>
                      </td>
                    ))}
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>
      </div>
      <FooterPreview pageNumber={pageNumber} reportType={reportType} />
    </div>
  );
}
